import { useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { useReducedMotion } from "framer-motion";

const photos = [
  { src: "/education/training-01.jpg", alt: "Участники обучения WMT AI работают за ноутбуками в учебном зале" },
  { src: "/education/training-02.jpg", alt: "Преподаватели WMT AI проводят обучение для команды" },
  { src: "/education/training-03.jpg", alt: "Участники обсуждают рабочие задачи на практикуме WMT AI" },
  { src: "/education/training-04.jpg", alt: "Выступление WMT AI об AI-трансформации компаний" },
  { src: "/education/training-05.jpg", alt: "Преподаватели и участники на практическом занятии WMT AI" },
];

export default function EducationPhotoSlider() {
  const reduceMotion = useReducedMotion();
  const [viewportRef, api] = useEmblaCarousel({ loop: true, duration: reduceMotion ? 0 : 40 });
  const [selected, setSelected] = useState(0);

  useEffect(() => {
    if (!api) return;
    const update = () => setSelected(api.selectedScrollSnap());
    update();
    api.on("select", update);
    api.on("reInit", update);
    return () => { api.off("select", update); api.off("reInit", update); };
  }, [api]);

  useEffect(() => {
    if (!api || reduceMotion) return;
    const interval = window.setInterval(() => {
      if (!document.hidden) api.scrollNext();
    }, 3000);
    return () => window.clearInterval(interval);
  }, [api, reduceMotion]);

  return <div className="education-slider" role="region" aria-roledescription="карусель" aria-label="Фотографии обучения WMT AI">
    <div className="education-slider-viewport" ref={viewportRef}>
      <div className="education-slider-track">
        {photos.map((photo, index) => <div key={photo.src} className="education-slider-slide" role="group" aria-roledescription="слайд" aria-label={`${index + 1} из ${photos.length}`} aria-hidden={selected !== index}>
          <img src={photo.src} alt={photo.alt} width={960} height={1200} loading="lazy" />
        </div>)}
      </div>
    </div>
  </div>;
}
